import { ChakraProvider, Box } from "@chakra-ui/react";
import Header from "./components/header/header";
import { lightTheme } from "./components/theme/light";
import { createContext, useContext, useEffect, useState } from "react";
import { darkTheme } from "./components/theme/dark";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import HomeScreen from "./Screens/home/home";
import "./App.css";
import Footer from "./components/footer/footer";
import ProfessionalPath from "./Screens/path/professionalPath";
import SocialMedia from "./components/SocialMedia/socialMedia";
import GeneralCategories from "./Screens/generalCategories/generalCategories";
import InscriptionForm from "./Screens/inscriptionForm/inscriptionForm";
import GestarInCompany from "./Screens/inCompany/inCompany";
import Community from "./Screens/community/community";
import AboutUs from "./Screens/aboutUs/aboutUs";
import DrawerMenu from "./components/header/headerComps/drawerMenu/DrawerMenu";
import { getCategories, getCoursesInfo, getVercel } from "./utils/dataFetch";
import WhatsAppButton from './components/botonwp/WhatsAppButton';
import ScrollToTop from './components/ScrollToTop/ScrollToTop.jsx';
import FormCurl from './FormCurl';
import TopBanner from './components/banner/TopBanner';
import ReturnPolicy from "./Screens/ReturnPolicy/ReturnPolicy";


const AppContext = createContext();
export const useAppContext = () => {
  return useContext(AppContext)
}
export default function App() {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [searcherText, setSearcherText] = useState('');
  const [modeFilter, setModeFilter] = useState(null);
  const [appType, setAppType] = useState('');
  const [categories, setCategories] = useState(null);
  const [diploma, setDiploma] = useState(null);
  const [secretarys, setSecretarys] = useState(null);
  const [coursesInfo, setCoursesInfo] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [drawerSelection, setDrawerSelection] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 860);
  const [mode, setMode] = useState(true);
  const [topBannerVisible, setTopBannerVisible] = useState(() => {
  const isHidden = localStorage.getItem('gestar_top_banner_hidden');
  return isHidden !== 'true';
});

  const style = styles(isMobile);

  useEffect(() => {
  Promise.all([
    getCategories("courses"),
    getCategories("diploma"),
    getCategories("secretary"),
    getCoursesInfo(),
  ])
  .then(([categories, diplomas, secretarys, courses]) => {
    setCategories(categories);
    setDiploma(diplomas);
    setSecretarys(secretarys);
    setCoursesInfo(courses);
  });

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 860);
  };
  window.addEventListener('resize', handleResize);

  // Captura y guarda el gclid si existe en la URL
  const params = new URLSearchParams(window.location.search);
  const gclid = params.get("gclid");
  if (gclid) {
    const expiryDate = new Date().getTime() + 90 * 24 * 60 * 60 * 1000; // 90 días
    const gclidRecord = { value: gclid, expiryDate };
    localStorage.setItem("gclid", JSON.stringify(gclidRecord));
  }

  return () => {
    window.removeEventListener('resize', handleResize);
  };
}, []);

  const toggleDrawer = () => {
    setOpenDrawer(!openDrawer);
  }
  const valueForProvider = {
    ...(mode? lightTheme : darkTheme),
  }
  const categoryItems = categories || [];
  const appContextValue = {
    diploma,
    coursesInfo,
    secretarys,
    categoryItems,
    isMobile,
    searcherText,
    selectedCategory,
    modeFilter, 
    drawerSelection, 
    appType,
    setModeFilter,
    setDrawerSelection,
    setAppType,
    setCategories,
    setSelectedCategory,
    setSearcherText,
    toggleDrawer
  }
  
  return (
    <AppContext.Provider value={appContextValue}>
      <ChakraProvider theme={valueForProvider}>
        <Router>
          <ScrollToTop /> {/* <-- Agregalo acá */}
          <TopBanner visible={topBannerVisible} setVisible={setTopBannerVisible} />
          <Header setMode={setMode} mode={mode} bannerVisible={topBannerVisible} />
          <Box height={topBannerVisible ? "128px" : "80px"} />
          {!isMobile && <SocialMedia customStyles={style.socialMedia}/>}
          {isMobile && <DrawerMenu isOpen={openDrawer}/>}
          <Routes>
            <Route path="/" element={<HomeScreen/>} />
            <Route path="/home" element={<HomeScreen/>} />
            <Route path="/in-company" element={<GestarInCompany/>} />
            <Route path="/comunidad" element={<Community/>} />
            <Route path="/sobre-nosotros" element={<AboutUs/>} />
            <Route path="/trayectoria" element={<ProfessionalPath/>} />
            <Route path="/categorias-general/:type" element={<GeneralCategories/>} />
            <Route path="/categorias-general/:type/:categoryName" element={<GeneralCategories/>} />
            <Route path="/formulario-inscripcion/:type/:categoryName/:IdCurso" element={<InscriptionForm/>} />
            <Route path="/test-form" element={<FormCurl />} />
            <Route path="/politica-devoluciones" element={<ReturnPolicy />} />
          </Routes>
          <WhatsAppButton />
          <Footer />
        </Router>
      </ChakraProvider>
    </AppContext.Provider>
  );
}

const styles = (isMobile) => ({
  socialMedia:{
    container: {
      position: 'fixed',
      right: isMobile? 20:50,
      top: 100,
      display: 'flex',
      flexDirection: 'column',
      zIndex: 100
    },
    circleColor: lightTheme.background.secondary
  }
})
